import React, { Component } from "react";
import "./InfoKey.css";

class InfoKey extends Component {
  render() {
    return (
      <div style={{ textAlign: "center", width: "140%" }}>
        <div className="rowLayout">
          <div className="col-12">
            <h5 className="legendtitle">Performance Tiers Color Key</h5>
          </div>
        </div>
        <div
          className="rowLayout"
          style={{ marginBottom: "1em", marginTop: "-1em" }}
        >
          <div className="col-3 keyText">
            <div className="legend model">Model</div>
            <div className="legendscore model">100-75%</div>
          </div>
          <div className="col-3 keyText">
            <div className="legend reinforce">Reinforce</div>
            <div className="legendscore reinforce">74-50%</div>
          </div>
          <div className="col-3 keyText">
            <div className="legend watch">Watch</div>
            <div className="legendscore watch">49-25%</div>
          </div>
          <div className="col-3 keyText">
            <div className="legend intervene">Intervene</div>
            <div className="legendscore intervene">24-0%</div>
          </div>
        </div>
      </div>
    );
  }
}

export default InfoKey;
